export default {"src":"/_next/static/media/NoCodeDeployment.262b8fc1.svg","height":304,"width":744};